/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getPlatformUserWhitelistTable = params => {
  return axios.post(`${base}/query_user`, params)
}
export const exportPlatformUserWhitelistData = params => {
  return axios.get(`${base}/exportPlatformUserWhitelistData/${params.id}`, {params})
}
export const queryPlatformUserWhitelistData = params => {
  return axios.get(`${base}/get_grayrelease_tag`, params)
}
export const deletePlatformUserWhitelistData = params => {
  return axios.post(`${base}/delete_user_batch_tag`, params)
}



// WEBPACK FOOTER //
// ./src/views/platform-user-whitelist/platform-user-whitelist.api.js